module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/customer-form/customer-form.component.css
// module id = ./src/app/customer-form/customer-form.component.css
// module chunks = main